import React, { useState } from 'react';
import { useRotationStore } from '../../context/RotationContext';
import { useVesselStore } from '../../context/VesselContext';
import CommonTooltip from '../ui/tooltip/CommonTooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InfoButton } from '../../styles/button.style';
import { RotationInfoWrapper, RotationContextInfo, RotationInfoItem, InfoButtonWrapper } from './RotationInfo.styles';
import RotationInfoPanelComponent from './rotationInfoPanel/RotationInfoPanel';

const RotationInfo: React.FC = () => {
    const { updatedRotation, nextPortCall, currentPortCall } = useRotationStore();
    const { selectedVessel } = useVesselStore();
    const [isInfoButtonSelected, setIsInfoButtonSelected] = useState<boolean>(false);

    const getCurrentVoyage = () => {
        if (updatedRotation) {
            return (
                <RotationInfoItem>
                    <CommonTooltip tooltipId="RotationInfo.CurrentVoyage">
                        <label>Current voyage</label>
                    </CommonTooltip>
                    <div>{currentPortCall?.voyageNumberPresentationString}</div>
                    <CommonTooltip tooltipId="RotationInfo.CurrentLocation">
                        <label>Current location</label>
                    </CommonTooltip>
                    <div>{currentPortCall?.name}</div>
                    <CommonTooltip tooltipId="RotationInfo.UpcomingDestination">
                        <label>Upcoming destination</label>
                    </CommonTooltip>
                    <div>{nextPortCall?.name}</div>
                </RotationInfoItem>
            );
        }
        return null;
    };

    const handleInfoButton = () => {
        setIsInfoButtonSelected(!isInfoButtonSelected);
    };

    const onInfoRotationCancel = () => {
        setIsInfoButtonSelected(false);
    };

    const getRotationInfoPanel = () => {
        if (isInfoButtonSelected) {
            return <RotationInfoPanelComponent onOk={onInfoRotationCancel} isOpen={isInfoButtonSelected} />;
        }
        return null;
    };

    const getInfoIcon = () => {
        if (updatedRotation) {
            return (
                <InfoButtonWrapper>
                    <InfoButton isSelected={true} onClick={handleInfoButton} title="Rotation information">
                        <FontAwesomeIcon icon="info" />
                    </InfoButton>
                </InfoButtonWrapper>
            );
        }
        return null;
    };

    return (
        <>
            {selectedVessel && (
                <RotationInfoWrapper>
                    <RotationContextInfo>{getInfoIcon()}</RotationContextInfo>
                    <RotationContextInfo>{getCurrentVoyage()}</RotationContextInfo>
                    {getRotationInfoPanel()}
                </RotationInfoWrapper>
            )}
        </>
    );
};

export default RotationInfo;
